/// <reference path="third-party/jquery/2.x/jquery-2.0.0.js"/>
/// <reference path="~/Content/Scripts/third-party/bundled/moment.js" />


"use strict";

window.IREP = window.IREP || {};

var IREP = window.IREP;
/*
  IREP.options = {
    Can be found in MotechMaster.cs
    AppUrl =  string mapping "~/" relative url, ie "/ww/"
    ApiUrl = string mapping the api root url from the web.config, ie "http://192.168.2.195/api/"
    User = {
        // the properties from UserData
    }
    PJaxTimeout = timeout used before pjax aborts the ajax load and does a full page load
    IsRTL = bool for directional goodness
  }
*/

IREP = $.extend(IREP, (function () {

    var options = {};

    var init = function (configOptions) {
        IREP.options = options = configOptions;

        //Removing due to error in safari private browsing
        //sessionStorage.setItem('user', JSON.stringify(IREP.options.user));

        var cultureCode = configOptions.user.cultureCode;
        cultureCode = cultureCode === "en-US" ? "en" : cultureCode;

        if (configOptions.isMotech === true) {
            moment.lang(cultureCode);
        }

        var showRelativeDates = function() {
            $.each($(".moment"), function(index, item) {
                var that = $(item);
                var momentDate = moment(that.data("date"));
                var relativeDate = momentDate.fromNow();
                if (that.data("showActualDate")) {
                    that.text(that.attr("title"));
                    that.attr("title", relativeDate);
                } else {
                    that.text(relativeDate);
                }

            });
        };
        showRelativeDates();

        var regex = new RegExp("/mini-profiler-resources/");
        $(document).ajaxError(function(event, jqXHR, settings, exception) {
            if (!regex.test(settings.url)) {
                if (jqXHR.status == 401) {
                    var url = window.location.pathname;
                    var redirectUrl = IREP.options.appUrl + "?goto=" + url;
                    redirect(redirectUrl);
                }
            } else {
                // TODO: do we have an ajax failed notice for the user?
            }
            return false;
        });

        $.extend({
            // http://stackoverflow.com/a/7124052
            encodeHTML: function(value) {
                return String(value)
                    .replace(/&/g, "&amp;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#39;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;");
            },

            // http://stackoverflow.com/a/7124052
            decodeHTML: function(value) {
                return String(value)
                    .replace(/&amp;/g, "&")
                    .replace(/&quot;/g, '"')
                    .replace(/&#39;/g, "'")
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">");
            }
        });

        $.fn.extend({
            // serialize child form elements into an array suitable for using with an ajax call
            serializeForm: function() {
                var formElements = $("input, select, textarea", this);
                var data = [];
                $.each(formElements, function(i, item) {
                    var element = $(item);
                    data.push({ name: element.prop("name").match(/.*\$(.*)/)[1], value: element.val() });
                });
                return data;
            }
        });

        // because asp.net webforms essentially forces you to wrap your entire page in a <form runat="server">
        // and that won't work with wanting ajax submissions and needing to limit the data passed,
        // use "<div class="form"> to simulate a form and be able to bind to a submit event
        var handleFakeForm = function() {
            var fakeForm = $(this);
            fakeForm.trigger("submit");
            return false;
        };

        var handleFakeFormKey = function(event) {
            if (event.which === 13) {
                handleFakeForm();
            }
        };

        $(document).on("keypress", ".form", handleFakeFormKey).on("click", ".form button[type='submit'], .form input[type='submit']", handleFakeForm);

        $.ajaxSetup({
            cache: false
        });

        if ($.support.pjax) {
            $(document).on("click", "a[data-pjax]", function (event) {
                var container = $(this).parents("[data-pjax-container]");
                $.pjax.click(event, { container: container, timeout: configOptions.pJaxTimeout });
            });
        }

        $(document).on('pjax:error', function (xhr, textStatus, errorThrown) {           
            if (textStatus.status == 401) {
                xhr.preventDefault();
                redirect("/logout");
            }
        });

        $(document).on("pjax:success", function() {
            showRelativeDates();
        });

        if (configOptions.isMotech === true) {
            Handlebars.registerHelper("decimal", function(number) { return number.toFixed(1); });
            Handlebars.registerHelper("add1", function(index) { return index + 1; });
            IREP.bands.init();
        }
    };

    var oldSchoolCallApi = function (url, type, data, doneCallback, failCallback) {
        var xhr = $.ajax({
            dataType: "json",
            url: IREP.options.apiUrlSecure + url,
            contentType: 'application/json',
            type: type,
            headers: { "PaxUID": IREP.options.user.currentUID },
            data: type === "POST" ? JSON.stringify(data) : data
        });
        if (typeof doneCallback === "function") {
            xhr.done(doneCallback);
        }
        if (typeof failCallback === "function") {
            xhr.fail(failCallback);
        }

        return xhr.promise();
    };

    var newSchoolCallApi = function (options) {
        options = $.extend({}, { type: 'GET', secure: false, anonymous: false, data: {}, headers: {} }, options);
        var headers = $.extend({}, { "PaxUID": options.anonymous ? '' : IREP.options.user.currentUID }, options.headers);

        var xhr = $.ajax({
            dataType: "json",
            url: this.options.apiUrlSecure + options.url,
            contentType: 'application/json',
            type: options.type,
            headers: headers,
            data: options.type === "POST" ? JSON.stringify(options.data) : options.data
        });

        return xhr.promise();
    };

    var callApi = function () {
        
        if (arguments.length === 1) {
            return newSchoolCallApi.apply(this, arguments);
        } else {
            return oldSchoolCallApi.apply(this, arguments);
        }
    };

    var redirect = function (url) {
        // window.location.href doesn't work in IE8, and I don't want to globally change this and deal with the browser differences
        // PJAX doesn't support IE8, so this is effectively an IE8 check
        if ($.support.pjax) {
            window.location.href = url;
        } else {
            window.location = url;
        }
    };
    var refresh = function() {
        window.location.reload();
    };

    var displayError = function(message) {
        alert(message);
    };

    var generateSiteLink = function(url) {
        return IREP.options.appUrl + IREP.options.user.site.toLowerCase() + url;
    };

    var track = function(code, type, label, value, data) {
        return this.callApi({ type: "POST", url: '/tracker', data: { code: code, type: type, label: label, value: value, data: data } });
    };

    var logTimings = function () {
        if (!(window.performance && window.performance.timing)) {
            return;
        }
        var timings = {
            url: window.location.pathname,
            querystring: window.location.search,
            hash: window.location.hash,
            latency: window.performance.timing.responseStart - window.performance.timing.fetchStart,
            transfer: window.performance.timing.responseEnd - window.performance.timing.responseStart,
            domInteractive: window.performance.timing.domInteractive - window.performance.timing.domLoading,
            domComplete: window.performance.timing.domComplete - window.performance.timing.domInteractive,
            onLoad: window.performance.timing.loadEventEnd - window.performance.timing.loadEventStart
        };
        this.callApi({ type: 'POST', url: 'cerebro/ct', data: timings });
    };

    return {
        init: init,
        callApi: callApi,
        redirect: redirect,
        refresh: refresh,
        displayError: displayError,
        generateSiteLink: generateSiteLink,
        track: track,
        logTimings: logTimings,
        options: options
    };

})());
